export const createOrdersUrl = (
  filters: Record<string, string | number | undefined>
): string => {
  const filteredSearchParamsObj: Record<string, string> = {};
  for (const key in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, key)) {
      const value = filters[key];
      if (value !== undefined && value !== '') {
        filteredSearchParamsObj[key] = value.toString();
      }
    }
  }

  if (filters instanceof URLSearchParams) {
    return `${import.meta.env.VITE_API_URL}/api/admin/orders?${filters.toString()}`;
  } else if (typeof filters === 'object') {
    const params = new URLSearchParams(filteredSearchParamsObj);
    return `${import.meta.env.VITE_API_URL}/api/admin/orders?${params.toString()}`;
  } else {
    throw new Error('Недопустимый тип параметров поиска');
  }
};
